import { Pipe, PipeTransform } from '@angular/core';

import { Flag } from '@models/common/flag.model';
import { find } from 'lodash';

@Pipe({
  name: 'corporationFlags',
})
export class CorporationsFlagsPipe implements PipeTransform {
  transform(corporationFlagsData: {
    flags: Flag[] | undefined;
    key: string;
  }): boolean {
    const flag = find(corporationFlagsData.flags, {
      name: corporationFlagsData.key,
    });
    if ((flag && !flag?.value) || flag === undefined) {
      return false;
    } else {
      return true;
    }
  }
}
